import {createReducer} from '@reduxjs/toolkit';

import {enhancedMosaic} from '@explorer/util/mosaics';
import {
  fetchSeriesMosaicsRequest,
  selectMosaic,
  selectMosaicByName,
} from '@explorer/actions/mosaics';
import {selectSeries} from '@explorer/actions/series';

export const initialState = {
  loading: false,
  error: null,
  list: [],
  selected: null, // definition of the selected mosaic.
};

const mosaics = createReducer(initialState, builder => {
  builder.addCase(fetchSeriesMosaicsRequest.pending, state => {
    state.loading = true;
    state.error = null;
  });

  builder.addCase(fetchSeriesMosaicsRequest.fulfilled, (state, {payload}) => {
    const newMosaics = payload.mosaics
      .map(mosaic => {
        return {
          ...enhancedMosaic(mosaic),
          seriesId: payload.seriesId,
          seriesName: payload.seriesName,
        };
      })
      .sort((a, b) => {
        const dateA = new Date(a.first_acquired);
        const dateB = new Date(b.first_acquired);
        return dateA > dateB ? -1 : 1;
      });

    state.loading = false;
    state.list = newMosaics;
    state.error = null;
  });

  builder.addCase(fetchSeriesMosaicsRequest.rejected, (state, {error}) => {
    state.loading = false;
    state.error = error;
  });

  builder.addCase(selectMosaic.pending, () => {
    // TODO: Should this be indicated? It's nearly always fast.
  });

  builder.addCase(selectMosaic.fulfilled, (state, {payload: mosaic}) => {
    state.selected = mosaic ? enhancedMosaic(mosaic) : mosaic;
  });

  builder.addCase(selectMosaicByName.fulfilled, (state, {payload: mosaic}) => {
    state.selected = mosaic ? enhancedMosaic(mosaic) : mosaic;
  });

  builder.addCase(selectMosaic.rejected, () => {
    // TODO: This should likely make a toast
  });

  builder.addCase(selectSeries, (state, {payload: seriesId}) => {
    // clear out selection if we are selecting a different series
    if (seriesId && state.selected?.seriesId !== seriesId) {
      state.selected = null;
    }
  });
});

export default mosaics;
